import produce from 'immer';
import type { RemoteData } from '../async-actions';
import { createFetchAction } from '../async-actions';
import * as Hub from '../ogm-hub';

// ======
// State
// ======

export interface MassChangeHomeViewModel {
	canStartNewMassChange: boolean;
	requests: Hub.MassChangeHomeResult_MassChangeRequest[];
}

export interface MassChangeHomeState {
	viewModel: RemoteData<MassChangeHomeViewModel, string[]>;
}

export function initialState(): MassChangeHomeState {
	return {
		viewModel: {
			type: 'initial',
		},
	};
}

export function MassChangeHomeReducer(
	state: MassChangeHomeState = initialState(),
	action: MassChangeHome
): MassChangeHomeState {
	return produce(state, (next) => {
		if (action.type === '@mch:MASS_CHANGE_HOME_LOADED_PENDING') {
			next.viewModel = { type: 'loading' };
			return;
		}

		if (next.viewModel.type === 'loading') {
			if (action.type === '@mch:MASS_CHANGE_HOME_LOADED_SUCCESS') {
				next.viewModel = {
					type: 'success',
					data: action.payload,
				};
				return;
			}
		}
	});
}

// ========
// Actions
// ========

export type MassChangeHome =
	| MASS_CHANGE_HOME_LOADED_PENDING
	| MASS_CHANGE_HOME_LOADED_FAILURE
	| MASS_CHANGE_HOME_LOADED_SUCCESS;

export interface MASS_CHANGE_HOME_LOADED_PENDING {
	type: '@mch:MASS_CHANGE_HOME_LOADED_PENDING';
}
export interface MASS_CHANGE_HOME_LOADED_FAILURE {
	type: '@mch:MASS_CHANGE_HOME_LOADED_FAILURE';
	errors: string[];
}
export interface MASS_CHANGE_HOME_LOADED_SUCCESS {
	type: '@mch:MASS_CHANGE_HOME_LOADED_SUCCESS';
	payload: Hub.MassChangeHomeResult;
}

export interface MassChangeHomeLoadedArgs {
	customerId: number;
}

export const MassChangeHomeLoaded = createFetchAction<
	MassChangeHomeLoadedArgs,
	MASS_CHANGE_HOME_LOADED_PENDING,
	MASS_CHANGE_HOME_LOADED_FAILURE,
	MASS_CHANGE_HOME_LOADED_SUCCESS
>(
	'@mch:MASS_CHANGE_HOME_LOADED_PENDING',
	'@mch:MASS_CHANGE_HOME_LOADED_FAILURE',
	'@mch:MASS_CHANGE_HOME_LOADED_SUCCESS',
	async () => {
		const res = await Hub.ProductController.MassChangeHomePage();
		return res;
	}
);
